import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveTextAlign(theme, screenWidth, textAlginSupport) {
    var result = {};
    if (textAlginSupport.textAlign !== undefined) {
        result.textAlign = resolveResponsiveValue(theme, screenWidth, textAlginSupport.textAlign);
    }
    return result;
}
//# sourceMappingURL=TextAlignResolver.js.map